import { render, staticRenderFns } from "./forgotPasStepOne.vue?vue&type=template&id=ebec8c92&"
import script from "./forgotPasStepOne.vue?vue&type=script&lang=js&"
export * from "./forgotPasStepOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports